import React from "react";
import "./Contact.css";
import ContactForm from "./ContactForm/Contact Form";

const Contact = () => {
  return (
      <main className='main'>
        <section className="contact-section section container" id="contact">
            <ContactForm />
        </section>
      </main>
  );
};

export default Contact;
